<span *ngIf="!isGlobalUser" class="blueText" (click)="setUnsetFavourite(isFavorite)">
    <i class="fa-heart" [ngClass]="(isFavorite)?'fas':'far'"></i>
</span>
<!-- <span *ngIf="!isFavorite && isGlobalUser" class="blueTextNoClick"><i class="far fa-heart"></i></span>
<span *ngIf="isFavorite && isGlobalUser" class="blueTextNoClick"><i class="fas fa-heart"></i></span> -->
{{params.value}}
